import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { LogoMark } from "@/components/Brand";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, ChevronRight, FileText } from "lucide-react";

export default function SignBundle() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => { api.get(`/sign-all/${token}`).then((r) => setData(r.data)).catch((e) => setError(formatApiError(e.response?.data?.detail) || "This link is not valid")); }, [token]);
  if (error) return <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="sign-bundle-error"><LogoMark className="mx-auto mb-6" /><p className="text-destructive">{error}</p></div>;
  if (!data) return <div className="max-w-xl mx-auto px-4 py-24 text-center text-sm text-muted-foreground">Loading…</div>;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10" data-testid="sign-bundle-page">
      <div className="flex items-center gap-3 mb-6"><LogoMark /><span className="text-xs uppercase tracking-widest text-muted-foreground">Policy sign-off</span></div>
      <div className="bg-card border border-border rounded-2xl p-6 mb-6">
        <p className="text-sm text-muted-foreground">{data.org_name || data.requester}</p>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight mt-1">Your policies to read and sign</h1>
        <p className="mt-3 text-sm"><b data-testid="sign-bundle-pending">{data.pending}</b> to sign · <b data-testid="sign-bundle-signed">{data.signed}</b> signed · recorded against {data.email}</p>
      </div>
      <ul className="divide-y divide-border rounded-2xl border border-border bg-card" data-testid="sign-bundle-list">
        {data.policies.map((p) => (
          <li key={p.token}>
            {p.status === "signed" ? (
              <div className="flex items-center gap-3 px-4 py-3 text-sm" data-testid={`sign-bundle-item-signed-${p.title}`}>
                <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0" />
                <span className="flex-1"><span className="font-medium">{p.title}</span><span className="block text-xs text-muted-foreground">{p.sector_label}</span></span>
                <Badge className="bg-emerald-100 text-emerald-800 hover:bg-emerald-100">Signed {new Date(p.signed_at).toLocaleDateString("en-GB")}</Badge>
              </div>
            ) : (
              <Link to={`/sign/${p.token}`} className="flex items-center gap-3 px-4 py-3 text-sm hover:bg-muted/40" data-testid={`sign-bundle-item-${p.title}`}>
                <FileText className="w-5 h-5 text-muted-foreground shrink-0" />
                <span className="flex-1"><span className="font-medium">{p.title}</span><span className="block text-xs text-muted-foreground">{p.sector_label}</span></span>
                <span className="text-primary text-xs font-medium inline-flex items-center">Read &amp; sign <ChevronRight className="w-4 h-4" /></span>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
